/* eslint-disable @next/next/no-img-element */
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

import LeadButton from '@/components/LeadButton';
import Title from '@/components/Title';

const list = [
  { name: '私教课-标签-1', id: 1 },
  { name: '私教课-标签-2', id: 2 },
  { name: '私教课-标签-3', id: 3 },
  { name: '私教课-标签-4', id: 4 },
  { name: '私教课-标签-5', id: 5 },
];
const PersonalCoach = () => {
  const { t, i18n } = useTranslation(['chinese', 'path']);
  return (
    <div className=" relative mb-[22px] mt-[48px] text-center lg:mb-[120px] lg:mt-[140px] xl:mb-[120px] xl:mt-[200px]">
      <div className="container">
        <div className="container hidden lg:block xl:block">
          <div className=" absolute left-1/2 top-[-30px] h-full w-full translate-x-[-50%] lg:h-[480px] lg:w-[562px] xl:h-[400px] xl:w-[800px]">
            <Image alt="WuKong" width={800} height={400} src="/images/chinese/personl-coach-bg.png" quality={100} />
          </div>
        </div>
        <Title className="mb-[4px] lg:tracking-[0.96px] xl:tracking-[0.96px]" innerHTML theme="red">
          {`${t('私教课-标题')}`}
        </Title>
        <section className="m-auto mt-6 flex flex-wrap justify-center gap-[12px] text-[14px] lg:mb-[32px] lg:mt-[24px] lg:gap-[20px] lg:text-[16px] xl:mb-[40px] xl:mt-[40px] xl:w-[1220px] xl:gap-[24px] xl:text-[16px]">
          {list.map((item) => (
            <h3
              key={item.id}
              className="flex items-center rounded-[50px] bg-[linear-gradient(90deg,rgba(255,83,83,0.12)_8.55%,rgba(109,56,251,0.12)_61.14%,rgba(0,157,255,0.12)_100%)] px-4 py-[4px] text-center text-[14px] font-normal leading-normal text-wk-words-1 lg:text-[16px] xl:text-[20px] [&_strong]:contents"
              dangerouslySetInnerHTML={{ __html: t(item.name) }}
            />
          ))}
        </section>
        <div className="lg:m6-12 m-auto  mb-3 mt-8 h-[180px] w-[320px] lg:h-[468px] lg:w-[814px] lg:rounded-3xl xl:my-15 xl:h-[627px] xl:w-[1114px] xl:rounded-4xl">
          <video
            className="video1 block h-full w-full  rounded-xl border-[2px] border-[#DFE0ED] bg-black object-cover  lg:rounded-[27px] lg:border-[5px] xl:rounded-5xl xl:border-[6px]"
            src={`https://cdnwukong.com/images/growth/video/chinese-video-${i18n?.language === 'en' ? 'en-250508' : 'zh-250508'}.mp4`}
            controlsList="nodownload, nofullscreen"
            playsInline
            x5-video-player-fullscreen="false"
            x5-playsinline="true"
            webkit-playsinline="true"
            loop
            autoPlay
            muted
            contextMenu="return false"
            disablePictureInPicture
            controls
          />
        </div>
        <div className="relative mt-[24px] lg:top-[0] lg:mb-[20px] lg:mt-[52px] xl:top-[0] xl:mb-[31px] xl:mt-[60px]">
          <LeadButton
            theme="red"
            size="xl"
            className=""
            subject="chinese"
            traceName="O_ChineseCourse_ClassroomIntroduction_CTAClick"
            traceGa4Name="new_entry_ChineseCourse_ClassroomIntroductionCTA"
          >
            {t('私教课-按钮')}
          </LeadButton>
        </div>
      </div>
    </div>
  );
};

export default PersonalCoach;
